import { FlowController } from "components/FlowController/FlowController";
import { ResetPasswordOtp } from "./ResetPasswordOtp";
import { RequestResetPassword } from "./RequestResetPassword";
import { ResetPasswordSuccess } from "./ResetPasswordSuccess";

import styles from "./password-recovery.module.scss";

export const PasswordRecovery = ({ location = {} }) => {
  const screens = {
    RequestResetPassword,
    ResetPasswordOtp,
    ResetPasswordSuccess,
  };
  const { state } = location;
  return (
    <div className={styles.wrapper}>
      <FlowController
        screens={screens}
        initialScreen={
          state?.currentStep === 3
            ? "ResetPasswordSuccess"
            : "RequestResetPassword"
        }
      />
    </div>
  );
};
